<template>
  <div class="challenge-campaigns-report">
    <div class="col-md-12 card text-left">
      <div class="card-header"></div>
      <div class="challenge-campaigns-report__filters">
        <input
          type="text"
          class="form-control challenge-campaigns-report__filter-id"
          v-model="challengeId"
          :placeholder="$t('challengeCampaigns.id')"
          @keyup.enter="loadReport"
        >
        <input
          type="text"
          class="form-control challenge-campaigns-report__filter-title"
          v-model="searchTitle"
          :placeholder="$t('challengeCampaigns.searchByTitle')"
          @keyup.enter="loadReport"
        >
        <el-date-picker
          type="daterange"
          v-model="dateRange"
          class="challenge-campaigns-report__filter-date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        />
        <el-select
          v-if="locations.length"
          v-model="locationId"
          clearable
          filterable
          class="challenge-campaigns-report__filter-location"
          :placeholder="$t('orders.location')"
        >
          <el-option
            v-for="loc in locations"
            :key="loc.id"
            :label="loc.name"
            :value="loc.id"
          />
        </el-select>
        <div
          :title="$t('reports.search')"
          class="btn btn-icon btn-info btn-search"
          @click="loadReport"
        >
          <i class="ti-search"></i>
        </div>
      </div>

      <p class="text-muted" style="padding: 0 15px; margin-top: 5px;">
        {{ $t('challengeCampaigns.reportDateHint') }}
      </p>

      <div class="card-content total-pagination pad-15" style="position: relative;">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>

        <el-table
          :data="tableData"
          style="width: 100%;"
          :empty-text="$t('gestiune.noData')"
          @row-click="onRowClick"
        >
          <el-table-column prop="id" :label="$t('challengeCampaigns.id')" width="70" />
          <el-table-column prop="title" :label="$t('challengeCampaigns.title')" min-width="160" />
          <el-table-column :label="$t('general.active')" width="90">
            <template slot-scope="p">
              {{ p.row.active ? $t('general.active') : $t('general.inactive') }}
            </template>
          </el-table-column>
          <el-table-column prop="completed_users" :label="$t('challengeCampaigns.completedUsers')" width="110" />
          <el-table-column prop="in_progress_users" :label="$t('challengeCampaigns.inProgressUsers')" width="110" />
          <el-table-column prop="started_users" :label="$t('challengeCampaigns.startedUsers')" width="100" />
          <el-table-column :label="$t('challengeCampaigns.completionRate')" width="140" class-name="challenge-completion-rate-col">
            <template slot-scope="p">{{ p.row.completion_rate }}%</template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { DatePicker, Select, Option } from 'element-ui'
Vue.use(DatePicker)
Vue.use(Select)
Vue.use(Option)

export default {
  props: { isChallengeCampaignsReport: { type: Boolean, default: false } },
  data () {
    return {
      loading: false,
      tableData: [],
      challengeId: '',
      searchTitle: '',
      dateRange: null,
      locationId: null,
      locations: [],
      pickerOptions: {
        firstDayOfWeek: 1
      }
    }
  },
  watch: {
    isChallengeCampaignsReport (v) {
      if (v) this.init()
    }
  },
  created () {
    if (this.isChallengeCampaignsReport) this.init()
    this.$bus.$on('refresh-challenge-report', this.loadReport)
  },
  beforeDestroy () {
    this.$bus.$off('refresh-challenge-report', this.loadReport)
  },
  methods: {
    init () {
      this.getLocations().then(() => this.loadReport())
    },
    getLocations () {
      return new Promise((resolve) => {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/get-locations', 'GET', data, (response) => {
          this.locations = response.status ? (response.data || []) : []
          resolve()
        })
      })
    },
    loadReport () {
      this.loading = true
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        date_from: (this.dateRange && this.dateRange[0]) ? (this.dateRange[0] + ' 00:00:00') : null,
        date_to: (this.dateRange && this.dateRange[1]) ? (this.dateRange[1] + ' 23:59:59') : null,
        location_id: this.locationId,
        challenge_id: (this.challengeId !== null && String(this.challengeId).trim() !== '')
          ? String(this.challengeId).trim()
          : null,
        search: (this.searchTitle || '').trim() || null
      }
      this.apiRequest('/reports/challenges', 'GET', data, (response) => {
        this.loading = false
        if (response.status) this.tableData = response.data || []
      })
    },
    onRowClick (row) {
      this.$router.push({
        path: '/reports/challenge-campaigns/' + row.id + '/users',
        query: { title: row.title }
      })
    }
  }
}
</script>

<style>
.challenge-campaigns-report .challenge-completion-rate-col .cell {
  white-space: nowrap;
}
.challenge-campaigns-report__filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  padding: 0 15px;
  width: 100%;
}
.challenge-campaigns-report__filter-id {
  width: 90px;
  flex: 0 0 90px;
}
.challenge-campaigns-report__filter-title {
  width: 200px;
  flex: 0 0 200px;
}
.challenge-campaigns-report__filter-date {
  width: 260px !important;
  flex: 0 0 260px;
}
.challenge-campaigns-report__filter-location {
  width: 180px;
  flex: 0 0 180px;
}
.challenge-campaigns-report__filters .btn-search {
  flex: 0 0 auto;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/ChallengeCampaignsReport.vue